"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightedIconType = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconSizes_1 = require("../Icons/PropTypes/IconSizes");
var HighlightedIconType;
(function (HighlightedIconType) {
    HighlightedIconType["Default"] = "default";
    HighlightedIconType["Info"] = "info";
    HighlightedIconType["Success"] = "success";
    HighlightedIconType["Danger"] = "danger";
    HighlightedIconType["Warning"] = "warning";
})(HighlightedIconType = exports.HighlightedIconType || (exports.HighlightedIconType = {}));
const HighlightedIcon = (_a) => {
    var { children, type = HighlightedIconType.Default, size = IconSizes_1.IconSizes.Default, className } = _a, props = __rest(_a, ["children", "type", "size", "className"]);
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)("gerudo-highlighted-icon", `gerudo-highlighted-icon-${type}`, size, className) }, props), (0, react_1.cloneElement)(children, { size })));
};
exports.default = HighlightedIcon;
//# sourceMappingURL=HighlightedIcon.js.map